import { z } from 'zod';

export const heroSchema = z.object({
  eyebrow: z.string().min(1),
  title: z.string().min(1),
  subtitle: z.string().min(1),
});

export type Hero = z.infer<typeof heroSchema>;
